<script lang="ts">
    import { Col, Table } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Extralarge, Extrasmall, GridOptions,GridOptionsMessage,GridOptionstitle, href, Large, Medium, Small,} from "../../../utils/Constant/Constant";
    import GrideOptionTable from "./GrideOptionTable.svelte";
</script>

<Col sm="12">
    <Card cardHeaderprops="pb-0"  headerTitle={GridOptions} headerContent={GridOptionstitle} >
        <div slot="contentbody">
            <p>
                {@html GridOptionsMessage}
            </p>
            <div class="table-responsive">
                <Table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th />
                            <th class="text-center">{Extrasmall}<br />
                                <small class="digits">&lt;576px</small>
                            </th>
                            <th class="text-center">{Small}<br />
                                <small class="digits">≥576px</small>
                            </th>
                            <th class="text-center">{Medium}<br />
                                <small class="digits">≥768px</small>
                            </th>
                            <th class="text-center">{Large}<br />
                                <small class="digits">≥992px</small>
                            </th>
                            <th class="text-center">{Extralarge}<br />
                                <small class="digits">≥1200px</small >
                            </th>
                        </tr>
                    </thead>
                    <GrideOptionTable />
                </Table>
            </div>
        </div>
    </Card>
</Col>
